<script setup lang="ts">
useSeoMeta({
  title: "Contact Us",
  description:
    "Do you need help? Reach out to our support team directly via these channels.",
});
</script>

<template>
  <main class="space-y-4">
    <h1>Contact Us</h1>
    <h2>Reach Out to Our Support Team</h2>
    <p>
      For personalized assistance or inquiries that aren't covered in our FAQs,
      you can contact our support team directly via these channels:
    </p>
    <address
      class="flex flex-col md:flex-row md:space-x-2 space-y-2 md:space-y-0 not-italic"
    >
      <help-contact-card
        name="IF Support"
        platform="Email"
        url="mailto:support@furries.id"
        icon="i-logos-google-gmail"
        avatar-url="/images/if-logo.png"
      />
      <help-contact-card
        name="Hopesa Cameraski"
        platform="Telegram"
        url="https://t.me/hopesa"
        icon="i-logos-telegram"
        avatar-url="/hopesa.jpg"
      />
    </address>
    <p>
      Our dedicated support team will get back to you promptly to assist with
      your concerns.
    </p>

    <p>
      Don't be shy! We're all ears for your questions, feedback, or anything
      else you'd like to chat about. Our friendly support team is here to assist
      you with tails wagging and paws ready to help.
    </p>
  </main>
</template>
